module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"buildingsCount":"Anzahl Liegenschaften","ebfSum":"Energiebezugsfläche","xUnit":"Liegenschaften","xUnitEbf":"m²","groupByKeys":{"usage":"Hauptnutzung","heating":"Heizungstyp","feasibility_ews":"Zulässigkeit Erdwärmesonden","feasibility_gw":"Zulässigkeit Grundwasser-Wärmenutzung","availability_district":"Verfügbarkeit Fernwärme"}}}')
  delete Component.options._Ctor
}
